import { render } from "./beforeRoom.vue?vue&type=template&id=2e78fe62&scoped=true"
import script from "./beforeRoom.vue?vue&type=script&lang=js"
export * from "./beforeRoom.vue?vue&type=script&lang=js"

import "./beforeRoom.vue?vue&type=style&index=0&id=2e78fe62&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e78fe62"]])

export default __exports__